import { Controller } from '@hotwired/stimulus';
import { useEventListener } from 'stimulus-library';

export default class extends Controller {
  static targets = ['closeButton', 'bar', 'body', 'container'];

  get mobileButton() {
    return document.querySelector('#open-mobile-nav-bar-button');
  }

  connect() {
    useEventListener(this, this.mobileButton, 'click', this.open);
    this.close();
  }

  open() {
    this.bodyTarget.classList.add('bg-gray-900/80');
    this.bodyTarget.classList.remove('bg-black/0');
    this.bodyTarget.classList.remove('pointer-events-none');

    this.barTarget.classList.remove('-translate-x-full');
    this.barTarget.classList.remove('pointer-events-none');
    this.barTarget.classList.remove('hidden');

    this.containerTarget.classList.remove('pointer-events-none');
  }

  close() {
    this.bodyTarget.classList.remove('bg-gray-900/80');
    this.bodyTarget.classList.add('bg-black/0');
    this.bodyTarget.classList.add('pointer-events-none');

    this.barTarget.classList.add('-translate-x-full');
    this.barTarget.classList.add('pointer-events-none');
    this.barTarget.classList.add('hidden');

    this.containerTarget.classList.add('pointer-events-none');
  }
}
